// extracted by mini-css-extract-plugin
module.exports = {"scoreLine":"e_ty","scoreRing":"e_uy","badge":"e_vy","badgeImage":"e_wy","spaced":"e_xy"};